import { useQuery } from "@tanstack/react-query";
import { getProfile } from "../../../services/queries/getProfile";
import useGraphQLQuery from "../../lib/useGraphqlQuery";

export const useProfileQuery = () => {
    // Custom Hook to use GraphQL Queries
    const graphQLQuery = useGraphQLQuery();
  
    // Get Profile Query
    const { data: profileData, isPending } = useQuery({
        queryKey: ["getProfile"],
        queryFn: () => graphQLQuery(getProfile),
    });

    return { profileData, isPending };
}